import { Outlet, Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth.tsx'
import { FileText, LogOut, Plus, User, Layers } from 'lucide-react'

function Layout() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <FileText className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-gray-900">Cloudflare Notes</span>
            </Link>

            {/* Navigation */}
            {user ? (
              <div className="flex items-center gap-4">
                <Link
                  to="/system"
                  className="btn-secondary hidden sm:flex"
                  title="System Dashboard"
                >
                  <Layers className="w-4 h-4 mr-1" />
                  System
                </Link>
                <Link
                  to="/notes/new"
                  className="btn-primary hidden sm:flex"
                >
                  <Plus className="w-4 h-4 mr-1" />
                  New Note
                </Link>
                
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <User className="w-4 h-4" />
                  <span className="hidden sm:inline">{user.name}</span>
                </div>
                
                <button
                  onClick={handleLogout}
                  className="btn-secondary"
                  title="Logout"
                >
                  <LogOut className="w-4 h-4 sm:mr-1" />
                  <span className="hidden sm:inline">Logout</span>
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <Link to="/system" className="btn-secondary hidden sm:flex">
                  <Layers className="w-4 h-4 mr-1" />
                  System
                </Link>
                <Link to="/login" className="btn-secondary">
                  Sign In
                </Link>
                <Link to="/register" className="btn-primary">
                  Get Started
                </Link>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Main content */}
      <main>
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <p className="text-center text-sm text-gray-500">
            Built with Cloudflare Workers, D1, R2, and AI
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Layout
